//----------------CORE-----------------//
import React from "react";
import { Link } from "react-router-dom";

// Shown when a URL names a solution this user cannot open — because their role
// does not grant it, or because it has been deleted.
//
// This is a common path, not an edge case: alarm recipients are a free-form
// email list on the rule, not a role-derived one, so a perfectly valid alarm
// email can reach someone without access to the solution it came from. On the
// LLA fleet service only 3 of 10 roles can open the link at all.
//
// Without this the routes for that solution simply never exist, every Switch in
// layouts/services.js renders null, and the user gets a navbar over blank grey
// space — which reads as broken rather than as "not yours".
export default function SolutionUnavailable() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        height: "calc(100vh - 200px)",
        textAlign: "center",
        padding: "0 20px",
      }}
    >
      <h2 style={{ margin: 0, fontWeight: 600 }}>This solution isn't available</h2>
      <p style={{ margin: 0, color: "#666", fontSize: "14px", maxWidth: "420px" }}>
        You may not have access to it, or it may have been removed. If you were
        sent this link, ask the person who sent it to check your access.
      </p>
      <Link
        to="/solutions/catalogue"
        style={{ marginTop: "6px", fontSize: "14px" }}
      >
        Back to solutions
      </Link>
    </div>
  );
}
